module.exports = __webpack_public_path__ + "img/whz.3765ff56.jpeg";